import { TagType } from 'lib/ui/tag';
import { match } from 'ts-pattern';
import { SnippetDb } from './snippetDb';

export function getSnippetCategoryName(category: SnippetDb.SnippetCategory): string {
	return match(category)
		.with('CooldownInstruction', () => 'Cooldown Instruction')
		.with('WarmupInstruction', () => 'Warmup Instruction')
		.with('Misc', () => 'Misc')
		.exhaustive();
}

export function getSnippetTagType(category: SnippetDb.SnippetCategory): TagType {
	return match(category)
		.returnType<TagType>()
		.with('WarmupInstruction', () => 'success')
		.with('CooldownInstruction', () => 'warning')
		.with('Misc', () => 'basic')
		.exhaustive();
}
